import { FiRefreshCw } from 'react-icons/fi'
import type { SalesforceSyncState } from '@/services/salesforceSync'

type SalesforceSyncButtonProps = {
  job: SalesforceSyncState
  onClick: () => void
  idleLabel: string
}

const SalesforceSyncButton = ({ job, onClick, idleLabel }: SalesforceSyncButtonProps) => {
  const percent = job.percent ?? 0
  return (
  <button
    type="button"
    onClick={onClick}
    disabled={job.status === 'running'}
    className="relative overflow-hidden flex items-center justify-center font-medium disabled:cursor-wait transition-opacity whitespace-nowrap"
    style={{
      height: '38px',
      minWidth: '220px',
      padding: '0 14px',
      color: job.status === 'running' && percent >= 45 ? '#FFFFFF' : '#212126',
      backgroundColor: '#FFFFFF',
      border: '1px solid #D9D9DE',
      borderRadius: '6px',
      gap: '8px',
      fontFamily: 'Lexend Deca',
    }}
  >
    <span
      aria-hidden
      style={{
        position: 'absolute',
        inset: 0,
        width: `${job.status === 'idle' ? 0 : percent}%`,
        backgroundColor: job.status === 'failed' ? '#FECACA' : '#137A43',
        transition: 'width 400ms ease',
      }}
    />
    <FiRefreshCw className={`relative z-10 w-4 h-4 ${job.status === 'running' ? 'animate-spin' : ''}`} />
    <span className="relative z-10">
      {job.status === 'running'
        ? `Syncing orders ${percent}%`
        : job.status === 'completed'
          ? 'Sync complete'
          : job.status === 'failed'
            ? 'Sync failed'
            : idleLabel}
    </span>
  </button>
  )
}

export default SalesforceSyncButton
